import { EntityService } from "src/app/core/services/entity.service";
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LiftDetail } from "../models/lift-detail.model";
import { LiftList } from "../models/lift-list.model";
import { LiftUpdate } from "../models/lift-update.model";
import { LiftCreate } from "../models/lift-create.model";

@Injectable({
  providedIn: 'root'
})
export class LiftService extends EntityService<LiftDetail, LiftList, LiftUpdate, LiftCreate> {
  constructor(
    httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(httpClient, baseUrl + 'api/lift');
  }

  update(lift: LiftUpdate) {
    const headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Lift-Id': String(lift.id) });

    return this.httpClient.put(this.apiUrl, JSON.stringify(lift), { headers: headers });
  }

  delete(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.delete(url);
  }
}
